import { useContext } from 'react';
import PropTypes from 'prop-types';

import SharedRenderContext from 'core/components/SharedRenderContext';

export default function withInitialBreakpoint(Component) {
  const InitialBreakpointProvider = props => {
    const { initialBreakpoint } = useContext(SharedRenderContext);

    return (
      <Component
        {...props}
        initialBreakpoint={props.initialBreakpoint || initialBreakpoint}
      />
    );
  };

  InitialBreakpointProvider.propTypes = {
    initialBreakpoint: PropTypes.string,
  };

  return InitialBreakpointProvider;
}
